import BaseModel from '../../common/models/base.model';

class User extends BaseModel {
  schema = {
    name: this.yup.string().required(this.requiredText),
    email: this.yup.string().email().required(this.requiredText),
    role: this.yup.number().integer().required(this.requiredText),
  }
}

export default User;
